// extracted by mini-css-extract-plugin
export var attachment = "_nb-a";
export var emailContainer = "_nb-4";
export var emailContentPaddedContainer = "_nb-b";
export var emailHeader = "_nb-6";
export var emailIframe = "_nb-3";
export var emailInfoIcon = "_nb-9";
export var emailShortenedSummary = "_nb-e";
export var infoDropdown = "_nb-0";
export var infoRowBoundedContent = "_nb-d";
export var internal = "_nb-5";
export var merchant = "_nb-8";
export var messageInputContainer = "_nb-h";
export var normal = "_nb-7";
export var replyCard = "_nb-f";
export var subtleButton = "_nb-1";
export var subtleButtonIconContainer = "_nb-2";
export var toggleViewRepliesButton = "_nb-c";
export var wrappingText = "_nb-g";